import { render, staticRenderFns } from "./received.vue?vue&type=template&id=7aa9b738&"
import script from "./received.vue?vue&type=script&lang=js&"
export * from "./received.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports